import { styled, Tab, Tabs } from "@mui/material";
import React from "react";
import archiveImg from "assets/icons/archive.svg";
import activeArchiveImg from "assets/icons/activeArchive.svg";
import { useCheckMenuPermission } from "hooks/useCheckMenuPermission";
import {ReactComponent as SubTabImage} from "assets/PwC_Funct_Icons_Archive_Outline_Black_RGB.svg"

const StyledSubTab = styled(Tab)(({ theme }) => ({
    textTransform: "none", // Prevent uppercase
    fontWeight: "400",
    fontSize: "16px",
    color: "#474747",
    padding: '0px',
    minHeight: '0',
    minWidth: '240px',
    padding: '5px 20px 5px 20px',
    lineHeight: '24px',
    borderRadius: '4px',
    letterSpacing: '-0.4px',
    backgroundColor: '#F3F3F3',
    "&.Mui-selected": {
        color: "#fff",
        // borderRadius: '10px',
        backgroundColor: `${theme?.customSettings?.themeColor}`,
        // padding: '6px'
    }
}));

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const SubTabs = (props) => {
    const { subTabs, selectedTab, selectedIndex, variant } = props;
    const { hasPermission } = useCheckMenuPermission();
    const handleChange = (_, newIndex) => {

        selectedTab(newIndex);
    };

    return (
        <Tabs value={selectedIndex} onChange={handleChange} aria-label="icon tabs example"
            variant={variant === undefined ? "fullWidth" : variant}
            scrollButtons="auto"
            sx={{
                mt: 1,
                backgroundColor: '#fff',
                borderRadius: '4px',
                "& .MuiTabs-indicator": {
                    height: '0px'
                },
                "& .MuiTab-root": {
                    margin: "5px 3px 5px 3px",
                    "&:first-of-type": {
                        marginLeft: '6px',
                    },
                    "&:last-of-type": {
                        marginRight: '6px',
                    },
                },
            }}
        >
            {/* {subTabs?.map} */}
            {subTabs?.filter(item => hasPermission([item?.permissionKey])).map(tab => (
                //  <StyledSubTab key={tab.index} label={tab.label} value={tab?.index} {...a11yProps(tab.index)} icon={<img src={selectedIndex == tab.index ? activeArchiveImg : archiveImg} alt="construction" style={{ width: '16px', height: '16px' }} />} iconPosition="start" aria-label={tab.path} sx={{ minWidth: tab?.minWidth }} />
                <StyledSubTab key={tab.index} label={tab.label} value={tab?.index} {...a11yProps(tab.index)} 
                icon={<SubTabImage style={{ width: '20px', height: '20px', stroke : selectedIndex == tab.index ? "#ffffff" : "#a9a9a9", strokeWidth:2, fill: selectedIndex == tab.index ? "#ffffff" : undefined }} />}
                iconPosition="start" aria-label={tab.path} sx={{ minWidth: tab?.minWidth }} />
            ))}
        </Tabs>
    );
};

export default SubTabs;
